export default __webpack_public_path__ + "static/media/ep21.9f3f1779.jpeg";